import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISection from 'UIComponents/section/UISection';
import H4 from 'UIComponents/elements/headings/H4';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import LearnMoreButton from './LearnMoreButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { ManageSeatsButton } from './ManageSeatsButton';
import { GetStartedButton } from './GetStartedButton';
import styled from 'styled-components';
import getAppUrls from '../../constants/appUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTitle = styled(H4).withConfig({
  displayName: "UnlockCallingItem__StyledTitle",
  componentId: "fye80v-0"
})(["font-size:18px;"]);
const USE_ATTRIBUTES = {
  default: {
    container_css: {
      border: `1px solid ${BATTLESHIP}`,
      maxWidth: '800px'
    },
    container_classname: 'p-top-12 p-bottom-8 p-x-12',
    illustration_left_classname: 'm-right-12',
    illustration_right_classname: 'm-left-12',
    illustration_width: '120',
    illustration_height: '140'
  },
  popover: {
    container_css: {},
    container_classname: 'p-top-8 p-bottom-1 p-x-10',
    illustration_left_classname: 'm-right-6',
    illustration_right_classname: 'm-left-6',
    illustration_width: '80',
    illustration_height: '100'
  }
};
export default function UnlockCallingItem(props) {
  const {
    use,
    blockingType,
    showIntegrationsLink = true,
    onTrack
  } = props;
  const computedUse = useMemo(() => {
    return use && USE_ATTRIBUTES[use] ? use : 'default';
  }, [use]);
  const isPaidSeatBlocking = blockingType === 'paid-seat-blocking';
  const {
    integrationsUrl
  } = getAppUrls();
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    className: USE_ATTRIBUTES[computedUse].container_classname,
    style: USE_ATTRIBUTES[computedUse].container_css,
    "data-test-id": props['data-test-id'],
    justify: "between",
    children: [isPaidSeatBlocking && /*#__PURE__*/_jsx(UIIllustration, {
      className: USE_ATTRIBUTES[computedUse].illustration_left_classname,
      name: "calling",
      alt: "calling",
      width: USE_ATTRIBUTES[computedUse].illustration_width
    }), /*#__PURE__*/_jsxs(UISection, {
      children: [/*#__PURE__*/_jsx(StyledTitle, {
        className: "m-top-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `calling-orchestration-shared-library.unlock-calling.${blockingType}.title`
        })
      }), /*#__PURE__*/_jsx(UISection, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `calling-orchestration-shared-library.unlock-calling.${blockingType}.description`
        })
      }), /*#__PURE__*/_jsx(UISection, {
        children: !isPaidSeatBlocking ? /*#__PURE__*/_jsx(GetStartedButton, {
          onTrack: onTrack
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ManageSeatsButton, {}), /*#__PURE__*/_jsx(LearnMoreButton, {})]
        })
      }), isPaidSeatBlocking && showIntegrationsLink && /*#__PURE__*/_jsx("small", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "calling-orchestration-shared-library.unlock-calling.alternative-link_jsx",
          elements: {
            UILink
          },
          options: {
            href: integrationsUrl
          }
        })
      })]
    }), !isPaidSeatBlocking && /*#__PURE__*/_jsx(UIIllustration, {
      name: "calling-set-up",
      alt: "calling-set-up",
      height: USE_ATTRIBUTES[computedUse].illustration_height,
      className: USE_ATTRIBUTES[computedUse].illustration_right_classname
    })]
  });
}